import { PageHeader } from "../components/PageHeader";
import { CTABand } from "../components/CTABand";
import { Reveal } from "../components/Reveal";
import { ServicesGrid } from "../components/sections";

export default function Services() {
  return (
    <div data-testid="services-page">
      <PageHeader
        eyebrow="Our operations"
        title="What we do"
        lead="Delivering quality, ensuring compliance, and building confidence across industries and communities — through six core service lines."
        crumb="Services"
      />
      <section className="section bg-mist">
        <div className="wrap">
          <Reveal className="sec-head">
            <span className="eyebrow">Core service lines</span>
            <h2>Comprehensive quality &amp; compliance services</h2>
            <p>Each service is delivered to a high standard of technical rigor and aligned with internationally recognized standards.</p>
          </Reveal>
          <ServicesGrid />
        </div>
      </section>
      <CTABand />
    </div>
  );
}
